module.exports = __webpack_public_path__ + "static/emmaus-web.1cd36599.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomeSlider/img/emmaus-web.jpg
// module id = 99
// module chunks = 19817326959855 213534597649335 219805994829571